import styled from "styled-components";
import {colors, sizes, fontSize} from "../../../../themes";

export const SideStampWrapper = styled.div`
  height: calc(100% - 31px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 40px;
  padding-left: 30px;
  padding-right: 30px;
  position: absolute;
  top: 16px;
  bottom: 15px;
  left: 15px;
  background: ${colors.background.lilyWhite};
  border-radius: 8px;
  @media only screen and ${sizes.max991} {
    height: initial;
    position: initial;
    padding: 7vw 6vw;
  }
`

export const SideStampRow = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 3px;
  font-style: normal;
  font-weight: 400;
  ${fontSize(14)}
  line-height: 160%;
  color: ${colors.text.chambray};
  :first-of-type {
    margin-bottom: 45px;
    justify-content: center;
  }
  :last-of-type {
    margin-bottom: 67px;
  }
  @media only screen and ${sizes.max991} {
    :first-of-type {
      margin-bottom: 9vw;
    }
    :last-of-type {
      margin-bottom: 13vw;
    }
  }
`;

export const MoreInfo = styled.span`
  font-style: normal;
  font-weight: 700;
  ${fontSize(14)}
  line-height: 120%;
  display: flex;
  align-items: center;
  color: ${colors.text.kleinBlue};
  cursor: pointer;
`;
